import { AutoFormSection } from "models/autoForm";
import { Task } from "features/Resources/Task/models";
import NewHireAutoSaveForm from "features/Form/Components/NewHireAutoSaveForm";
import NewHireInputForm from "../../NewHireInputForm";

interface FormSchema {
  sections: AutoFormSection[];
}

const INPUT_WORK_EMAIL = {
  sections: [{
    fields: [
      {
        name: "workEmail",
        type: "email",
        label: "Work Email",
        accessor: "newHire.workEmail",
        writer: "newHire.workEmail",
      },
    ],
  }],
} as FormSchema;

export function InputWorkEmailTaskActionForm({ task }: { task: Task }) {
  return <NewHireInputForm task={task} formSchema={INPUT_WORK_EMAIL} />;
}

export function InputWorkEmailForm({ task, onSuccess }: { task: Task, onSuccess: (res: any) => void }) {
  return <NewHireAutoSaveForm formSchema={INPUT_WORK_EMAIL} newHireId={task?.newHireJourneyId} onSuccess={onSuccess} />;
}
